import { Group, Switch, Text } from "@mantine/core";
import { IIssueBoardApi, IPredefinedTags } from "@schemas/issueBoardSchema";
import { ColDef } from "ag-grid-community";
import React from "react";
import { FailedAlert } from "../../../../components";
import ViewEditTable from "../../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../../components/ViewEditTable/ViewEditTableValidators";
import {
  usePostProjectByProjectIdIssueboardPredefinedtagsUpdateMutation,
  usePostProjectByProjectIdIssueboardUsepredefinedtagsUpdateMutation,
} from "../../../../../openapi";
import { useUpdateIssueBoardUseOnlyPredefinedTagsMutation } from "../IssueBoardRTK";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssuePredefinedTags: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [updateBoardCustomTags, { error: updateBoardCustomTagsError }] =
    usePostProjectByProjectIdIssueboardPredefinedtagsUpdateMutation();
  const [updateBoardUseCustomTags, { error: updateBoardErrorUseCustomTags }] =
    usePostProjectByProjectIdIssueboardUsepredefinedtagsUpdateMutation();
  const [updateBoardUseOnlyPredefinedTags, { error: updateBoardErrorUseOnlyPredefinedTags }] =
    useUpdateIssueBoardUseOnlyPredefinedTagsMutation();

  const columnSettings: ColDef<IPredefinedTags>[] = [
    {
      field: "title",
      headerName: "Tittel",
      editable: true,
    },
  ];

  return (
    <SettingsCardWrapper title={"Forhåndsdefinerte etiketter"}>
      {(updateBoardErrorUseCustomTags != null ||
        updateBoardCustomTagsError != null ||
        updateBoardErrorUseOnlyPredefinedTags != null) && <FailedAlert />}
      <Group align="center" gap="xs" wrap="nowrap">
        <Text size="1em">
          <i className="fa fa-info-circle fa-fw text-info" /> Bruk forhåndsdefinerte etiketter for register
        </Text>
        <Switch
          size="sm"
          onChange={(event) =>
            updateBoardUseCustomTags({
              projectId: issueBoard.project,
              body: {
                issueBoardId: issueBoard._id,
                useCustomTags: event.currentTarget.checked,
              },
            })
          }
          checked={issueBoard.usePredefinedTags === true}
        />
      </Group>
      <Group align="center" gap="xs" wrap="nowrap">
        <Text size="1em">
          <i className="fa fa-unlock fa-fw text-info" /> Tillat egendefinerte etiketter
        </Text>
        <Switch
          size="sm"
          onChange={(event) =>
            updateBoardUseOnlyPredefinedTags({
              projectId: issueBoard.project,
              issueBoardId: issueBoard._id,
              useOnlyPredefinedTags: !event.currentTarget.checked,
            })
          }
          checked={issueBoard.useOnlyPredefinedTags !== true}
          disabled={issueBoard.usePredefinedTags !== true}
        />
      </Group>
      <ViewEditTable
        canEdit={issueBoard.usePredefinedTags === true}
        columns={columnSettings}
        validators={[VETEmptyValidator]}
        data={issueBoard.predefinedTags ?? []}
        onSave={(tags) => {
          updateBoardCustomTags({
            projectId: issueBoard.project,
            body: {
              issueBoardId: issueBoard._id,
              tags: tags.map((tag) => ({ _id: tag._id, title: tag.title ?? "" })),
            },
          });
        }}
        newItemTemplateObject={{
          title: "",
        }}
      />
    </SettingsCardWrapper>
  );
};

export default IssuePredefinedTags;
